module.exports = __webpack_public_path__ + "static/media/darkClose.d69a5ed4.svg";